export default "__VITE_ASSET__6bbaf2fe__"